import { render, staticRenderFns } from "./Company_jobs.vue?vue&type=template&id=c2ccd136&scoped=true&lang=pug&"
import script from "./Company_jobs.vue?vue&type=script&lang=coffee&"
export * from "./Company_jobs.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ccd136",
  null
  
)

export default component.exports